import { useAuth } from '@/contexts/auth-context';
import { useChatContext } from '@/contexts/ChatContext';
import { useState, useCallback } from 'react';
export const useAuthenticatedAction = () => {
  const { user } = useAuth();
  const chatActions = useChatContext();
  const [showAuthDialog, setShowAuthDialog] = useState(false);

  const wrapAction = useCallback((action: (...args: any[]) => any) => {
    return (...args: any[]) => {
      if (!user) {
        setShowAuthDialog(true);
        return;
      }
      return action(...args);
    };
  }, [user, setShowAuthDialog]);

  // Wrap all relevant chat actions
  const sendMessage = wrapAction(chatActions.sendMessage);
  const handleFileUpload = wrapAction(chatActions.handleFileUpload);
  const removeFile = wrapAction(chatActions.removeFile);
  const stopStreaming = wrapAction(chatActions.stopStreaming);
  const cancelReply = wrapAction(chatActions.cancelReply);
  const createNewChat = wrapAction(chatActions.createNewChat);
  const deleteChat = wrapAction(chatActions.deleteChat);
  const handleRegenerate = wrapAction(chatActions.handleRegenerate);
  const toggleMessageVisibility = wrapAction(chatActions.toggleMessageVisibility);
  const handleMessageHover = wrapAction(chatActions.handleMessageHover);
  const handleReplyToMessage = wrapAction(chatActions.handleReplyToMessage);
  const startEditingTitle = wrapAction(chatActions.startEditingTitle);
  const cancelEditingTitle = wrapAction(chatActions.cancelEditingTitle);
  const saveChatTitle = wrapAction(chatActions.saveChatTitle);
  const handleEditMessage = wrapAction(chatActions.handleEditMessage);
  const handleCancelEdit = wrapAction(chatActions.handleCancelEdit);
  const handleSaveEdit = wrapAction(chatActions.handleSaveEdit);
  const handleFileSelect = wrapAction(chatActions.handleFileSelect);
  const sendFeedback = wrapAction(chatActions.sendFeedback);


  return {
    ...chatActions, // Spread all original actions
    // Override specific actions with authenticated versions
    sendMessage,
    handleFileUpload,
    removeFile,
    stopStreaming,
    cancelReply,
    createNewChat,
    deleteChat,
    handleRegenerate,
    toggleMessageVisibility,
    handleMessageHover,
    handleReplyToMessage,
    startEditingTitle,
    cancelEditingTitle,
    saveChatTitle,
    handleEditMessage,
    handleCancelEdit,
    handleSaveEdit,
    handleFileSelect,
    sendFeedback,
    // Expose dialog state and setter
    showAuthDialog,
    setShowAuthDialog,
  };
};
